import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

import { AutocompleteResult } from '../../models/autocomplete-result';

@Injectable()
export class ContactSearchService {
  private contactsFieldSearchURL = 'contacts/autocomplete_contact_by_name';

  private contactsURL = 'contacts';

  constructor(private httpClient: HttpClientService) {}

  contactsFieldSearch(term: string): Observable<AutocompleteResult[]> {
    console.log("contactsFieldSearchreturntype", this.httpClient.getObservable(`${this.contactsFieldSearchURL}.json?term=${term}`));
    return this.httpClient.getObservable(`${this.contactsFieldSearchURL}.json?term=${term}`).pipe(map((response) => response as AutocompleteResult[]));
  }

  getContactInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.contactsURL}/${id}.json`, { get_name: true });
  }

  getContactList(): Promise<any> {
    return this.httpClient.get(`${this.contactsURL}.json`);
  }
}
